import {AppThunkCreator} from "../../../../../setup/redux/Store";

import {actions} from "../NotificationRedux"
import {SnackbarKey} from "notistack";

export const removeNotification: AppThunkCreator<SnackbarKey> = (key) => (dispatch, getState) => {
    dispatch(actions.removeNotification(key));
}